import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Chip,
  Card,
  Link,
  TableContainer,
  Paper,
} from "@mui/material";

function OrdersList() {
  const navigate = useNavigate();
  const orders = [
    {
      id: 1,
      transaction_id: "107440964",
      order_id: "107440964",
      subscriptionId: "154789/459",
      invoice_id: "154789/459",
      transaction_date: "19 Aug 2024",
      amount: "₹ 1500",
      payment_method: "Card",
      transaction_status: "Completed",
    },
  ];

  const handleGrade = () => {
    navigate("/products/plan");
  };
  const handleRenew = () => {
    navigate("/products/pricing");
  };
  const getTransactionStatusLabel = (status) => {
    switch (status) {
      case "Completed":
        return (
          <Chip
            variant="outlined"
            size="small"
            label="Completed"
            color="success"
          />
        );
      case "Pending":
        return (
          <Chip
            variant="outlined"
            size="small"
            label="Pending"
            color="warning"
          />
        );
      case "Failed":
        return (
          <Chip variant="outlined" size="small" label="Failed" color="error" />
        );
      case "Refunded":
        return (
          <Chip
            variant="outlined"
            size="small"
            label="Refunded"
            color="error"
          />
        );
      default:
        return <Chip variant="outlined" size="small" label={status} />;
    }
  };

  return (
    <Card elevation={4}>
      <TableContainer component={Paper} sx={{ overflowX: "auto" }}>
        <Table sx={{ minWidth: 650, textAlign: "center" }}>
          <TableHead>
            <TableRow>
              <TableCell align="center">S.No</TableCell>
              <TableCell align="center">Transaction ID</TableCell>
              <TableCell align="center">Order ID</TableCell>
              <TableCell align="center">Business Subscription ID</TableCell>
              <TableCell align="center">Invoice Number</TableCell>
              <TableCell align="center">Transaction Date</TableCell>
              <TableCell align="center">Amount</TableCell>
              <TableCell align="center">Payment Method</TableCell>
              <TableCell align="center">Transaction Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {orders.map((order, index) => (
              <TableRow key={order.id}>
                <TableCell align="center">{index + 1}</TableCell>
                <TableCell align="center">{order.transaction_id}</TableCell>
                <TableCell align="center">{order.order_id}</TableCell>
                <TableCell align="center">{order.subscriptionId}</TableCell>
                <TableCell align="center">{order.invoice_id}</TableCell>
                <TableCell align="center">{order.transaction_date}</TableCell>
                <TableCell align="center">{order.amount}</TableCell>
                <TableCell align="center">{order.payment_method}</TableCell>
                <TableCell align="center">
                  {getTransactionStatusLabel(order.transaction_status)}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Card>
  );
}

export default OrdersList;
